import { theme_bfis } from "./../bfis/theme_bfis"

export const theme_bfis_send = theme_bfis
